import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var TaskQueue = /*#__PURE__*/function () {
  function TaskQueue(callback) {
    _classCallCheck(this, TaskQueue);
    this.callback = callback;
    this.waitingForTaskCompletion = false;
    this.queue = [];
  }
  return _createClass(TaskQueue, [{
    key: "enqueue",
    value: function enqueue(task) {
      if (this.waitingForTaskCompletion) {
        this.queue.push(task);
      } else {
        this.waitingForTaskCompletion = true;
        void this.runTask(task);
      }
    }
  }, {
    key: "isCompleted",
    value: function isCompleted() {
      return !this.waitingForTaskCompletion;
    }
  }, {
    key: "hasQueuedTasks",
    value: function hasQueuedTasks() {
      return this.queue.length > 0;
    }
  }, {
    key: "runTask",
    value: function () {
      var _runTask = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(task) {
        var result, nextTask;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return task.action(task.input);
            case 2:
              result = _context.sent;
              if (this.callback) {
                this.callback(result);
              }
              if (this.queue.length > 0) {
                nextTask = this.queue.shift();
                void this.runTask(nextTask);
              } else {
                this.waitingForTaskCompletion = false;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function runTask(_x) {
        return _runTask.apply(this, arguments);
      }
      return runTask;
    }()
  }]);
}();
